import React, { useEffect, useRef, useContext, useState } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import Button from "../../components/button";
import { FontSizeContext } from "../../context/fontSizeContext";

const ServiceProviderContainer = ({ mainData, contRef }) => {
    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    useEffect(() => {
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);
    }, []);
    return (
        <div className="single-service mb-5 mt-10" ref={contRef}>
            <div className="justify-content-center text-center">
                <div className="row justify-content-center">
                    {mainData &&
                        mainData.map((data, key) => {
                            return (
                                <div key={key} className={data.classOption}>
                                    <a href={data.link}>
                                        <i
                                            className={data.thumb}
                                            style={{
                                                backgroundColor: "#39b54a",
                                                borderRadius: "0.75rem",
                                            }}
                                        ></i>
                                        <h2
                                            className="text-primary mb-3 title"
                                            style={{
                                                fontFamily:
                                                    '"Open Sans", sans-serif',
                                                fontSize: "1.25rem",
                                            }}
                                        >
                                            <b>{data.title}</b>
                                        </h2>
                                        {data.id == 2 ? (
                                            <span>
                                                <a
                                                    href="tel:+18004195565"
                                                    className="d-color"
                                                    style={{ fontSize: "14px" }}
                                                >
                                                    18004195565
                                                </a>
                                                <br />
                                                <a
                                                    href="tel:+919820655655"
                                                    className="d-color"
                                                    style={{ fontSize: "14px" }}
                                                >
                                                    +91-9820655655
                                                </a>
                                            </span>
                                        ) : (
                                            <a
                                                href={data.link}
                                                className="d-color"
                                                style={{ fontSize: "14px" }}
                                            >
                                                {data.info}
                                            </a>
                                        )}
                                    </a>
                                </div>
                            );
                        })}
                </div>
            </div>

            <div className="container mt-10">
                <div className=" justify-content-center m-5 table-responsive">
                    {/* <img
                        src="/images/service/icon/escalation-matrix.png"
                        alt="NeoGrowth"
                        className="w-100 h-100 object-fit-cover d-block mb-10"
                    /> */}
                    <p className="b-color text-center">
                        To refer to the Grievance Redressal flowchart, kindly
                        click here:{" "}
                        <a
                            href={
                                process.env.PUBLIC_URL +
                                "/pdf/company-policies/CustomerGrievanceFlowChart.pdf"
                            }
                            target="_blank"
                            rel="noreferrer"
                        >
                            Grievance Redressal Flowchart
                        </a>
                    </p>
                    <table
                        className="b-color table align-middle"
                        style={{ fontSize: "14px" }}
                    >
                        <thead>
                            <tr>
                                <th className="y-background-color b-color text-center">
                                    <b>Escalation levels</b>
                                </th>
                                <th className="y-background-color b-color text-center">
                                    <b>Contact Point</b>
                                </th>
                                <th className="y-background-color b-color text-center">
                                    <b>Designation</b>
                                </th>
                                <th className="y-background-color b-color text-center">
                                    <b>Contact Information</b>
                                </th>
                                <th className="y-background-color b-color text-center">
                                    <b>Mode</b>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td
                                    style={{ verticalAlign: "middle" }}
                                    rowSpan="3"
                                    className="text-center"
                                >
                                    Level 0
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                    Central Helpline
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                    Customer Service Representative
                                </td>
                                <td>
                                    <ul style={{ borderBottom: "solid 0.9px" }}>
                                        <a
                                            href="tel:1800-419-5565"
                                            className="b-color"
                                        >
                                            1800-419-5565
                                        </a>{" "}
                                        /{" "}
                                        <a
                                            href="tel:9820 655 655"
                                            className="b-color"
                                        >
                                            9820 655 655
                                        </a>
                                    </ul>
                                    <br />
                                    Mon–Sat, 10:00 AM – 6:00 PM
                                </td>
                                <td
                                    style={{ verticalAlign: "middle" }}
                                    className="text-center"
                                >
                                    Phone
                                </td>
                            </tr>
                            <tr>
                                <td>Central Email Helpdesk</td>
                                <td>Customer Service Representative</td>
                                <td>
                                    <a
                                        className="text-green"
                                        href="mailto:helpdesk@neogrowth.in"
                                    >
                                        helpdesk@neogrowth.in
                                    </a>
                                </td>
                                <td className="text-center">Email</td>
                            </tr>
                            <tr>
                                <td>Branch / Walk-in / Letter</td>
                                <td>Designated Officer at Branch</td>
                                <td>Nearest NeoGrowth branch / By post</td>
                                <td className="text-center">
                                    Walk-in / Physical Letter
                                </td>
                            </tr>
                            <tr>
                                <td className="text-center">Level 1</td>
                                <td>Email Escalation (After 2 days)*</td>
                                <td>Manager – Customer Service</td>
                                <td>
                                    <a
                                        className="text-green"
                                        href="mailto:csmanager@neogrowth.in"
                                    >
                                        csmanager@neogrowth.in
                                    </a>
                                </td>
                                <td className="text-center">Email</td>
                            </tr>
                            <tr>
                                <td
                                    style={{ verticalAlign: "middle" }}
                                    rowSpan="2"
                                    className="text-center"
                                >
                                    Level 2
                                </td>
                                <td
                                    style={{ verticalAlign: "middle" }}
                                    rowSpan="2"
                                >
                                    Email Escalation (After 7 days)*
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                    Grievance Redressal Officer
                                </td>
                                <td>
                                    <a
                                        className="text-green"
                                        href="mailto:grievanceofficer@neogrowth.in"
                                    >
                                        grievanceofficer@neogrowth.in
                                    </a>
                                </td>
                                <td className="text-center">Email</td>
                            </tr>
                            <tr>
                                <td style={{ verticalAlign: "middle" }}>
                                    (Mrs. Bijal Patwa)
                                </td>
                                <td>
                                    <a
                                        href="tel:022-49219-932"
                                        className="d-color"
                                    >
                                        022- 49219 932
                                    </a>
                                </td>
                                <td className="text-center">Phone</td>
                            </tr>
                            <tr>
                                <td
                                    style={{ verticalAlign: "middle" }}
                                    rowSpan="2"
                                    className="text-center"
                                >
                                    Level 3
                                </td>
                                <td
                                    style={{ verticalAlign: "middle" }}
                                    rowSpan="2"
                                >
                                    Final Escalation (After 12 days)*
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                    Principal Nodal Officer
                                </td>
                                <td>
                                    <a
                                        className="text-green"
                                        href="mailto:nodalofficer@neogrowth.in"
                                    >
                                        nodalofficer@neogrowth.in
                                    </a>
                                </td>
                                <td className="text-center">Email</td>
                            </tr>
                            <tr>
                                <td style={{ verticalAlign: "middle" }}>
                                    (Ms. Neha Israni)
                                </td>
                                <td>
                                    <a
                                        href="tel:022-49219-930"
                                        className="d-color"
                                    >
                                        022-49219-930
                                    </a>
                                </td>
                                <td className="text-center">Phone</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p style={{ fontSize: "12px" }} className="mt-4 b-color">
                    *The timeline starts after seven working days from when the
                    customer first raises a query, request, or complaint through
                    given modes of communication.
                </p>
                <b>Note :</b> <br />
                <p
                    style={{ fontSize: "13px", paddingLeft: "8px" }}
                    className="b-color"
                >
                    <b>1. CMS – RBI Portal: </b>
                    <br />
                    If any complaint lodged by the borrower against the
                    NeoGrowth is rejected wholly or partly by the NeoGrowth, or
                    the borrower is not satisfied with the reply; or the
                    borrower has not received any reply within 30 days of
                    receipt of complaint by the NeoGrowth, the said borrower can
                    lodge a complaint over the Complaint Management System (CMS)
                    portal (
                    <a
                        target="_blank"
                        rel="noreferrer"
                        className="text-green"
                        href="https://cms.rbi.org.in"
                    >
                        https://cms.rbi.org.in
                    </a>
                    ) under the Reserve Bank-Integrated Ombudsman Scheme
                    (RB-IOS) or send a physical complaint to “Centralised
                    Receipt and Processing Centre, 4th Floor, Reserve Bank of
                    India, Sector -17, Central Vista, Chandigarh - 160017” as
                    per the grievance redressal mechanism prescribed by the
                    Reserve Bank. <br />
                    <br />
                    <b>2. Insurance‑Related Complaints: </b>
                    <br />
                    Customers may first access the above Grievance Redressal
                    Matrix of NeoGrowth and/or directly contact the concerned
                    Insurer’s Grievance Redressal Cell / Principal Officer,
                    details of which are available at:{" "}
                    <a
                        target="_blank"
                        rel="noreferrer"
                        className="text-green"
                        href="https://irdai.gov.in/web/guest/list-of-gros"
                    >
                        https://irdai.gov.in/web/guest/list-of-gros
                    </a>
                    <br />
                    In case the customer is dissatisfied or not satisfied with
                    the resolution, they may further escalate the complaint
                    through the following external forums, as applicable:
                    <br /> IRDAI – Bima Bharosa Portal:{" "}
                    <a
                        target="_blank"
                        rel="noreferrer"
                        className="text-green"
                        href="https://bimabharosa.irdai.gov.in"
                    >
                        https://bimabharosa.irdai.gov.in
                    </a>
                    <br />
                    Insurance Ombudsman:{" "}
                    <a
                        target="_blank"
                        rel="noreferrer"
                        className="text-green"
                        href="https://cioins.co.in/Complaint/Online"
                    >
                        https://cioins.co.in/Complaint/Online
                    </a>
                </p>
            </div>
            <div className="container mt-7">
                <div className="row justify-content-center">
                    <h5 className="">Following to be noted -</h5>
                    <ul className="list-items-dot mt-3">
                        <li className=" justify-content-center b-color">
                            <p>
                                The <b>TDS</b> Refund claims need to be applied
                                via the Merchant portal and it will take TAT of
                                15 working days to be processed depending upon
                                the monthly TDS submission cycle. For more
                                details
                                <a
                                    href={
                                        process.env.PUBLIC_URL +
                                        "/pdf/extra/TDS_Process_for_NeoGrowth.pdf"
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {" "}
                                    click here.
                                </a>
                            </p>
                        </li>
                        <li className=" justify-content-center b-color">
                            <p>
                                The <b>Credit bureau</b> related query to be
                                raised with our Helpdesk Team and the TAT will
                                be of 07 working days to be updated post
                                communication from CI.
                            </p>
                        </li>
                        <li className=" justify-content-center b-color">
                            <p>
                                All our <b>communications</b> are sent ONLY to
                                the Registered Mobile Number or on the
                                Registered Email Address updated in our system.
                            </p>
                        </li>
                        <li className=" justify-content-center b-color">
                            <p>
                                In-case of any <b>change or correction</b> to
                                the registered contact details, we request you
                                to to call us on our Toll-Free Numbers /
                                Helpdesk Email id.
                            </p>
                        </li>
                        <li className=" justify-content-center b-color">
                            <p>
                                For <b>documents</b> such as Loan statement,
                                Repayment schedule and Interest certificate you
                                may download the NeoGrowth customer application
                                as a DIY.
                            </p>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="single-service pt-10">
                <div className="container">
                    <h2 className="title g-color text-center">
                        <b>Locations We Serve</b>
                    </h2>
                </div>
            </div>
        </div>
    );
};

ServiceProviderContainer.propTypes = {
    mainData: PropTypes.any,
    contRef: PropTypes.any,
};

export default ServiceProviderContainer;
